import {
    primaryColor,
    dangerColor,
    roseColor,
    grayColor,
} from '../material-kit-pro-react';
import * as colors from '../../../constants/Colors';

const RadioStyles = {
    checkboxAndRadio: {
        position: 'relative',
        display: 'block',
        marginTop: '10px',
        marginBottom: '10px',
    },
    checkboxAndRadioHorizontal: {
        position: 'relative',
        display: 'block',
        '&:first-child': {
            marginTop: '10px',
        },
        '&:not(:first-child)': {
            marginTop: '-14px',
        },
        marginTop: '0',
        marginBottom: '0',
    },
    checked: {
        color: `${colors.white} !important`,
    },
    checkedIcon: {
        width: '16px !important',
        height: '16px !important',
        backgroundColor: colors.pictonBlue,
        border: '1px solid rgba(0, 0, 0, 0.84)',
    },
    uncheckedIcon: {
        width: '0 !important',
        height: '0 !important',
        padding: '8px',
        border: '1px solid rgba(0, 0, 0, 0.84)',
    },
    disabledCheckboxAndRadio: {
        '& $checkedIcon,& $uncheckedIcon,& $radioChecked,& $radioUnchecked': {
            borderColor: colors.black,
            opacity: '0.26',
            color: colors.black,
        },
    },
    labelRoot: {
        display: 'block',
    },
    label: {
        cursor: 'pointer',
        paddingLeft: '0',
        fontSize: '14px',
        lineHeight: '1.428571429',
        fontWeight: '400',
        display: 'inline-flex',
        transition: '0.3s ease all',
    },
    labelHorizontal: {
        color: 'rgba(0, 0, 0, 0.26)',
        cursor: 'pointer',
        display: 'inline-flex',
        fontSize: '14px',
        lineHeight: '1.428571429',
        fontWeight: '400',
        paddingTop: '39px',
        marginRight: '0',
        '@media (min-width: 992px)': {
            float: 'right',
        },
    },
    labelHorizontalRadioCheckbox: {
        paddingTop: '22px',
    },
    labelLeftHorizontal: {
        color: 'rgba(0, 0, 0, 0.26)',
        cursor: 'pointer',
        display: 'inline-flex',
        fontSize: '14px',
        lineHeight: '1.428571429',
        fontWeight: '400',
        paddingTop: '22px',
        marginRight: '0',
    },
    labelError: {
        color: dangerColor,
    },
    radio: {
        color: `${colors.darkslategray} !important`,
    },
    disabled: {
        pointerEvents: 'none',
    },
    radioChecked: {
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        border: `1px solid ${colors.darkslategray}`,
    },
    radioUnchecked: {
        width: '0px',
        height: '0px',
        padding: '7px',
        border: `1px solid ${colors.darkslategray}`,
        borderRadius: '50%',
    },
    inlineChecks: {
        marginTop: '8px',
    },
    iconCheckbox: {
        height: '116px',
        width: '116px',
        color: grayColor,
        '& > span:first-child': {
            borderWidth: '4px',
            borderStyle: 'solid',
            borderColor: colors.silver,
            textAlign: 'center',
            verticalAlign: 'middle',
            borderRadius: '50%',
            color: 'inherit',
            margin: '0 auto 20px',
            transition: 'all 0.2s',
        },
        '&:hover': {
            color: roseColor,
            '& > span:first-child': {
                borderColor: roseColor,
            },
        },
    },
    iconCheckboxChecked: {
        color: roseColor,
        '& > span:first-child': {
            borderColor: roseColor,
        },
    },
    iconCheckboxIcon: {
        fontSize: '40px',
        lineHeight: '111px',
    },
    switchBase: {
        color: `${primaryColor}!important`,
    },
    switchIcon: {
        boxShadow: '0 1px 3px 1px rgba(0, 0, 0, 0.4)',
        color: `${colors.white} !important`,
        border: '1px solid rgba(0, 0, 0, .54)',
        transform: 'translateX(-4px)!important',
    },
    switchIconChecked: {
        borderColor: colors.seance,
        transform: 'translateX(0px)!important',
    },
    switchBar: {
        width: '30px',
        height: '15px',
        backgroundColor: colors.emperor,
        borderRadius: '15px',
        opacity: '0.7!important',
    },
    switchChecked: {
        '& + $switchBar': {
            backgroundColor: 'rgba(156, 39, 176, 1) !important',
        },
    },
};

export default RadioStyles;
